import { Badge } from '@/components/ui/badge'

export const AlertBadge = ({ unreadAlerts }: { unreadAlerts: number }) => {
  return (
    <Badge variant="alert" className="px-3 py-1">
      <span className="inline-block w-2 h-2 bg-red-500 rounded-full mr-2"></span>
      {unreadAlerts} Alert{unreadAlerts !== 1 ? 's' : ''}
    </Badge>
  )
}
